import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=824bc48a&scoped=true"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&id=824bc48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824bc48a",
  null
  
)

export default component.exports